import React from 'react';
import { useHistory } from 'react-router';
import PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SimpleModal from '../SimpleModal';

const ExportModal = (props) => {
  const { t } = useTranslation();
  const {
    type,
    open,
    onCancel,
    onConfirm,
  } = props;

  const history = useHistory();

  const handleConfirm = () => {
    let path = '';
    onConfirm();
    switch (type) {
      case 'leads':
      case 'customers':
        path = type;
        break;
      case 'submissions':
        path = `campaigns/${type}`;
        break;
      default:
        break;
    }

    if (path) {
      history.push(`/${path}/past_exports`);
    }
  };

  return (
    <SimpleModal
      title={t('export_modal.title', 'Exporting...')}
      open={open}
      onCancel={onCancel}
      content={(
        <div>
          <Typography variant="body2">
            {t('export_modal.description', "We'll update you via email as soon as the CSV file is ready to be downloaded. It should take less than 15 minutes")}
          </Typography>
        </div>
    )}
      buttons={(
        <Button
          variant="contained"
          onClick={handleConfirm}
        >
          {t('component.label.okay', 'Okay')}
        </Button>
    )}
    />
  );
};

ExportModal.propTypes = {
  type: PropTypes.oneOf(['leads', 'customers', 'submissions']),
  open: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
};

ExportModal.defaultProps = {
  type: 'leads',
  open: false,
  onCancel: () => {},
  onConfirm: () => {},
};

export default ExportModal;
